<template>
  <div class="event-item" :style="eventStyle">
    <div class="event-item-hours"> 
      <iconAvaliacao :color="colorseparador"/>
    </div>
    <div class="event-item-info">
      <div class="disciplina">{{ $t('avaliacaoItem') }} - {{ tipo }} - {{ disciplina }}</div>
      <div class="minfo">
        <div class="moreinfo">{{ startHour }} - {{ endHour }}</div> 
        <div class="moreinfo">{{ formatSala(sala) }}<template v-if="piso != null"> - {{ $t("piso") }} {{ piso }}</template></div>  
        <div class="moreinfo">{{ $t('docente') }}: {{ getDocenteLabel(professor) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { isArray } from '@vue/shared';
import iconAvaliacao from '@/components/iconAvaliacao.vue';

export default {
  name: 'eventItem',
  props:["colorbackground","colorseparador","disciplina","sala","professor",
    "tipo","horaInicio","horaFim","ano","turma","piso"],
  components:{
    iconAvaliacao
  },
  computed:{
    eventStyle(){
      return {
        'border-left': `3px solid ${this.colorseparador}`
      }
    },
    startHour(){
      return this.horaInicio.slice(0,5);
    },
    endHour(){
      return this.horaFim.slice(0,5);
    },
  }, 
  methods:{
    getDocenteLabel(docente) {
      if (isArray(docente)) {
        return docente.join(", ")
      }
      return docente
    },
    formatSala(salas) {
      if (isArray(salas)) {
        return salas.join(", ")
      }
      return salas
    },
  }
}
</script>


<style scoped lang="scss">

$margin-from-center: 10px;
$main-font: "Montserrat"; 

img{
  width: 50px;
}

.place{
  width: 30px;
}

.clock{
  font-size: 18px;
  margin-left: 6px;
}

.event-item {
  display: flex;
  padding: 10px;
  padding-top: 10px;
  padding-left: 20px;
  font-size: 13px;
  background-color: #f6f6f6;
}

.event-item-hours, .event-item-info {
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
}

.event-item-hours{
  font-family: $main-font;
  padding-right: $margin-from-center;
}

.event-item-info {
  padding-left: $margin-from-center;
  flex-basis: 85%;
  justify-content: flex-start;
}

.disciplina{
  font-family: $main-font;
  margin-bottom: 3px;
  color: #111;
  font-size: 15px;
  line-height: 1.2;
  font-family: "Montserrat Light";
}
.other,.sala,.hour{
  font-family: "PT Sans";
}

.minfo{
  display: flex;
  flex-direction: row;
  margin-top: 2px;
}

.moreinfo{
  font-family: "PT Sans";
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 13px;
}

.moreinfo:not(:last-of-type)::after{
  content: "";
  width: 1px;
  height: 75%;
  background: #888;
  display: block;
  margin-left: 10px;
  margin-right: 10px;
}

.moreinfo i{
  font-size: 21px;
  margin-right: 5px;
}

.sala{
  font-size: 12px;
}

@media only screen and (max-width: 767px) {
  .event-item {
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
  }

  .disciplina {
    font-family: "Montserrat";
    font-size: 13px;
  }

  .minfo{
    flex-wrap: wrap;
  }

  .moreinfo {
    flex: 0 0 50%;
  }

  .moreinfo:nth-child(1){
    flex: 0 0 30%;
  }

  .moreinfo:nth-child(1)::after{
    margin-left: 11px;/*20px;*/
    margin-right: 0;
  }

  .moreinfo:nth-child(2){
    flex: 0 0 70%;
  }

  .moreinfo:nth-child(2)::after{
    margin-left: 0;
    margin-right: 0;
    width: 0;
  }

  .moreinfo:nth-child(3){
    margin-top: 5px;
    flex: 1;
  }
}

</style>